module.exports = __webpack_public_path__ + "img/estelle.63acee8f.webp";